module.exports = __webpack_public_path__ + "fonts/edex-icons.99b5d458.woff";